import useCurrentUser from "./useCurrentUser";

const useGetCompanyId = () => {
  const { user } = useCurrentUser();

  return { companyId: user.permissions ? user.permissions.companyId || user.id : null };
};

export default useGetCompanyId;
